import { PartialEmotionCanvasTheme } from '@workday/canvas-kit-react/common';
// eslint-disable-next-line no-restricted-imports
import { base, system } from '@workday/canvas-tokens-web';
import { WcpStyles } from '@workday/wcp-tokens';

export const darkTheme: PartialEmotionCanvasTheme = {
  canvas: {
    palette: {
      error: {
        main: WcpStyles.color.text.critical,
      },
      primary: {
        // Background
        lightest: `var(${system.color.bg.primary.stronger})`,
        // Background Secondary
        light: `var(${system.color.bg.primary.strong})`,
        // Border Light
        main: `var(${system.color.fg.primary.default})`,
        // Border Medium
        dark: `var(${system.color.fg.primary.soft})`,
        // Border Dark
        darkest: `var(${system.color.fg.primary.soft})`,
        // Text
        contrast: `var(${system.color.fg.inverse})`,
      },
      neutral: {
        // Background
        lightest: `var(${base.slate900})`, // doesn't have a system token equivalent
        // Background Secondary
        light: `var(${system.color.bg.muted.strong})`,
        // Border Light
        main: `var(${system.color.bg.alt.default})`,
        // Border Medium
        dark: `var(${system.color.bg.alt.soft})`,
        // Border Dark
        darkest: `var(${system.color.bg.alt.softer})`,
        // Text
        contrast: `var(${system.color.fg.inverse})`,
      },
    },
  },
};

export const lightTheme: PartialEmotionCanvasTheme = {
  canvas: {
    palette: {
      error: {
        main: WcpStyles.color.text.critical,
      },
      neutral: {
        // Menu/Select/Combobox item hover background (maps to brand.neutral.lightest,
        // aka --cnvs-brand-l — the only Canvas Kit consumer of this token). Must differ
        // from the menu surface (bg.default) or the hover state is invisible.
        lightest: WcpStyles.color.bg.alt.soft,
        // Background Secondary
        light: WcpStyles.color.bg.alt.softer,
        // Border Light
        main: `var(${system.color.border.divider})`,
        // Border Medium
        dark: `var(${system.color.border.container})`,
        // Border Dark
        darkest: `var(${system.color.border.input.default})`,
        // Text
        contrast: `var(${system.color.fg.strong})`,
      },
    },
  },
};
